import React from "react";

export const TeacherPicker = ({ teachers, value, onChange, testid = "teacher-picker" }) => {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  if (!teachers.length) return <div className="text-xs text-arc-muted mt-1">Nenhum professor cadastrado.</div>;
  return (
    <div className="flex flex-wrap gap-2 mt-1" data-testid={testid}>
      {teachers.map((t) => {
        const on = value.includes(t.id);
        return (
          <button type="button" key={t.id} onClick={() => toggle(t.id)} data-testid={`${testid}-${t.id}`} aria-pressed={on}
            className="px-3 py-1.5 rounded-full text-xs font-bold border-2 transition-[background-color,color]"
            style={{ borderColor: "#06D6A0", background: on ? "#06D6A0" : "transparent", color: on ? "#fff" : "var(--arc-text)" }}>
            {on ? "✓ " : "+ "}{t.name}
          </button>
        );
      })}
    </div>
  );
};
